export default function VerifyEmailPage() {
  return (
    <div className="bg-white rounded-xl p-8 shadow-lifted text-center">
      <div className="w-16 h-16 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg className="w-8 h-8 text-sage" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>
      <h1 className="font-display text-heading-lg mb-2">Check your email</h1>
      <p className="text-warm-gray mb-8">
        We've sent you a verification link. Click the link to verify your email address.
      </p>
      <button className="btn-secondary">Resend email</button>
    </div>
  );
}
